import { Card, CardContent } from "@bcc/components/ui/card";
import {
  Package,
  AlertTriangle,
  TrendingDown,
  DollarSign,
  LucideIcon,
} from "lucide-react";
import { setInventoryStatsTestId } from "./inventory-stats.utils";

interface StatData {
  name: string;
  value: string;
  icon: string;
  iconBg: string;
  iconColor: string;
}

interface InventoryStatsProps {
  data: StatData[];
  testId?: string;
}

const iconMap: Record<string, LucideIcon> = {
  Package,
  AlertTriangle,
  TrendingDown,
  DollarSign,
};

interface StatCardProps {
  stat: StatData;
  index: number;
}

function StatCard({ stat, index }: StatCardProps) {
  const IconComponent = iconMap[stat.icon] || Package;

  return (
    <Card
      key={stat.name}
      testId={setInventoryStatsTestId(`stat-card-${index}`)}
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p
              className="text-sm font-medium text-muted-foreground"
              data-testid={setInventoryStatsTestId(`stat-label-${index}`)}
            >
              {stat.name}
            </p>
            <p
              className="mt-2 text-3xl font-bold tracking-tight"
              data-testid={setInventoryStatsTestId(`stat-value-${index}`)}
            >
              {stat.value}
            </p>
          </div>
          <div
            className={`flex h-12 w-12 items-center justify-center rounded-xl ${stat.iconBg}`}
          >
            <IconComponent className={`h-6 w-6 ${stat.iconColor}`} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function InventoryStats({ data, testId }: InventoryStatsProps) {
  return (
    <div
      data-testid={testId ?? setInventoryStatsTestId("container")}
      className="grid gap-4 md:grid-cols-2 lg:grid-cols-4"
    >
      {data.map((stat, index) => (
        <StatCard key={stat.name} stat={stat} index={index} />
      ))}
    </div>
  );
}
